export default function Settings() {
  return <h1>Configuración</h1>;
}
